import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="px-6 pb-16 pt-12" data-id="element-19" data-mp="1l9o6t8rmrzlq">
      <SectionHeading data-id="element-20" data-mp="1gd7fy6t1r74y">Frequently asked questions</SectionHeading>

      <ul className="mt-7 divide-y divide-cream-300 overflow-hidden rounded-2xl border border-cream-300 bg-white" data-id="element-21" data-mp="1gausje4is4ki">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <li key={faq.question} data-id="element-22" data-mp="242077pyq4qt8" data-mpi={index}>
              <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center gap-4 px-5 py-4 text-left" data-id="element-23" data-mp="240yt1cmevo7a">
                <span className="flex-1 text-[16px] font-medium text-ink-900" data-id="element-24" data-mp="noa0sck4tqgf">{faq.question}</span>
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-ink-500 transition-transform ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-25" data-mp="pi7h6es06slv" />
              </button>
              {isOpen ? <p className="px-5 pb-5 text-[15.5px] leading-[1.65] text-ink-500" data-id="element-26" data-mp="kiuw9zkozvlx">{faq.answer}</p> : null}
            </li>;
      })}
      </ul>
    </section>;
}